// Copyright (c) 2016 Deere & Company

export const getMatchingObjects = (keys, list, keyName = 'key') =>
    list.filter(item =>
        keys.some(key => item[keyName] === key)
    );

export const findSelectedObject = (key, list) => list.find(item => item.key === key);



// WEBPACK FOOTER //
// ./src/shared/services/key-matcher.js